import { render, staticRenderFns } from "./link-paper.vue?vue&type=template&id=08f234d7&scoped=true&"
import script from "./link-paper.vue?vue&type=script&lang=js&"
export * from "./link-paper.vue?vue&type=script&lang=js&"
import style0 from "./link-paper.vue?vue&type=style&index=0&id=08f234d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f234d7",
  null
  
)

export default component.exports